import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import AddEntryForm from './form'

const AddEntryDialog = React.forwardRef(function AddEntryDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => setDialogState({ open: true, processing: false })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Add Entry'
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<AddEntryForm onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

AddEntryDialog.propTypes = {
  onComplete: PropTypes.func
}

AddEntryDialog.defaultProps = {
  onComplete: () => {}
}

export default AddEntryDialog
